module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/login/simage-login/simage-login.component.css
// module id = ./src/app/pages/login/simage-login/simage-login.component.css
// module chunks = main